'use client'

import React, { type ReactNode } from 'react'

import { twMerge } from 'tailwind-merge'

export interface RecipientSectionsProps {
  children: ReactNode
  className?: string
}

/**
 * RecipientDetail.Sections
 *
 * Grid layout container for analytics sections.
 * Uses 2-column grid on large screens with staggered animation.
 */
export function RecipientSections({
  children,
  className,
}: RecipientSectionsProps) {
  return (
    <div
      className={twMerge(
        'grid grid-cols-1 gap-4 sm:gap-6 md:grid-cols-2',
        'animate-[fadeIn_300ms_ease-out]',
        className,
      )}
    >
      {children}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  )
}
